import React from 'react';
import {Helmet} from 'react-helmet-async';


const SeoComp = ({title, image,description}) => {
    const truncateDescription = description.slice(0, 150);
    const canonicalUrl = `${window.location.origin}${window.location.pathname}`;
    return <Helmet>
        <title>{title}</title>
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={title} />
        <meta property="og:site_name" content="Agendia" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:image" content={image} />
        <meta property="og:description" content={truncateDescription} />
        <meta name="description" content={truncateDescription} />
    </Helmet>
}

export default SeoComp;